import type { CookiePreferences } from '@/stores/cookie-consent.store'

const GA_ID = import.meta.env.VITE_GA_ID

declare global {
  interface Window {
    dataLayer?: unknown[]
  }
}

function gtag(..._args: unknown[]): void {
  window.dataLayer = window.dataLayer ?? []
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments)
}

let gaLoaded = false

function loadGa(): void {
  if (gaLoaded || !GA_ID) return
  gaLoaded = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  gtag('js', new Date())
  gtag('config', GA_ID, { send_page_view: false })
}

function toConsentParams(p: Pick<CookiePreferences, 'analytics' | 'marketing'>) {
  const marketing = p.marketing ? 'granted' : 'denied'
  return {
    analytics_storage: p.analytics ? 'granted' : 'denied',
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
  }
}

export function initConsentMode(): void {
  gtag('consent', 'default', toConsentParams({ analytics: false, marketing: false }))
}

export function applyConsent(state: { decided: boolean; preferences: CookiePreferences }): void {
  if (!state.decided) return

  gtag('consent', 'update', toConsentParams(state.preferences))

  if (state.preferences.analytics) loadGa()
}

export function trackPageView(path: string): void {
  if (!gaLoaded) return
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}
